<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
<!--      <div class="btn-box"></div>-->
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="付费方式" :selectKey="'paymentMethod'" :selectData="payTypeList" @search="search"/>
        <input-select :selectTitle="'付费状态'" style="margin-left: 10px;" :selectData="payStatusList" @search="search" :selectKey="'status'" />
      </div>
      <div>
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">付费时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: flex-end;">
      <input-search placeholder="付费人姓名/手机号/车牌号" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004012001') !== -1"
          value="导出"/>
        </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-pay-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "amount-allocation"
        },
        {
          value: "包月缴费"
        }
      ],
      // addCustom: 'amount-add',
      exportUrl: "",
      payTypeList: [],
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "1",
          label: "已缴费"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "付费人姓名"
        },
        {
          prop: "personPhone",
          label: "付费人手机"
        },
        {
          prop: "carNumber",
          label: "付费人车牌号"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        },
        {
          prop: "paymentMethod",
          width: "100",
          label: "付费方式"
        },
        {
          prop: "money",
          width: "100",
          label: "付费金额(元)"
        },
        {
          prop: "statusText",
          label: "付费状态",
          width: "100"
        },
        {
          prop: "consumeTime",
          label: "付费时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        paymentMethod: "",
        status: ""
      },
      timevalue: []
    };
  },
  created() {
    this.getCreateTime();
    this.getList();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportMonthRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&paymentMethod=${this.requestData.paymentMethod}&status=${
        this.requestData.status
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getMonthRecordPage, reqData)
        .then(res => {
          if (res.data.retCode == 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.consumeTime) {
                v.consumeTime = v.consumeTime.slice(0, 19);
              }
              if (v.status === "0") {
                v.statusText = "未缴费";
              } else if (v.status === "1") {
                v.statusText = "已缴费";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取记录失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    getList() {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          configType: 2
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleText = "月缴";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleText = "季缴";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleText = "半年缴";
              } else if (v.paymentCycle === "4") {
                v.paymentCycleText = "年缴";
              }
              v.key = v.paymentCycleText;
              v.label = v.paymentCycleText;
            });
            data.unshift({ key: "", label: "全部" });
            this.payTypeList = data;
          }
        })
        .catch(errorHandler("获取配置数据失败"));
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingPayRecord/MonthlyPayment.vue